export default __webpack_public_path__ + "static/media/device_not_supported_tablet.134b6191.png";